<template>
  <UiCard tag="li" class="group relative px-6 py-4">
    <Component
      :is="type === 'link' ? AppRouterLink : 'button'"
      :to="{ name: 'SeanceView', params: { id: value.id } }"
      :class="{ 'pointer-events-none': !value.ticketsLeft }"
      class="w-full text-left"
    >
      <div class="flex w-full items-center">
        <div class="w-full">
          <div class="mb-1 flex w-full justify-between gap-1">
            <UiDate
              v-if="mode === 'date'"
              :value="value.beginsAt"
              template="HH:mm"
              class="font-medium"
            />
            <div v-else class="font-medium lg:text-base">
              <UiDate :value="value.beginsAt" template="d" class="inline" />&nbsp;<UiDate
                :value="value.beginsAt"
                :template="isSameYear(value.beginsAt, new Date()) ? 'MMMM' : 'MMMM yyyy'"
                class="inline"
              />,&nbsp;<SeanceWeekDay :value="value.beginsAt" class="inline" />
            </div>
            <p v-if="value.ticketsLeft" class="font-medium">
              {{ toRub(value.priceRange.min) }}
            </p>
            <p v-else class="text-center text-text-secondary">распродано</p>
          </div>
          <p class="text-xs text-text-secondary">
            <template v-if="mode === 'date' && value.venue">
              {{ value.venue.title }}
            </template>
            <UiDate v-else :value="value.beginsAt" template="HH:mm" />
          </p>
        </div>
      </div>
    </Component>
  </UiCard>
</template>

<script lang="ts" setup>
import { isSameYear } from 'date-fns'
import { toRub } from '@/6_shared/lib'
import type { TimetableFilterMode } from '@/6_shared/model'
import { AppRouterLink, UiCard, UiDate } from '@/6_shared/ui'
import type { Seance } from '../../model'
import SeanceWeekDay from '../SeanceWeekDay.vue'

type PropType = {
  value: Seance
  type?: 'link' | 'button'
  mode: TimetableFilterMode
}

withDefaults(defineProps<PropType>(), {
  type: 'link'
})
</script>
